import _ from "lodash"
import { matchPath } from "react-router-dom"
import { getFeatureDetail } from "utils/feature"
import { createCardMediaPropsFromFileField } from "utils/props"

export const parseEntry = ({ attributes, id, ...rest }) => {
  return { ...attributes, ...rest, id }
}

export const parseEntries = (entries = []) => {
  if (!_.isArray(entries)) return []
  return entries.map(parseEntry)
}

export const getMatchPathOptionByFeatureId = (featureId) => {
  const [featureType] = `${featureId}`.split("-")
  const routePatterns = {
    occupant: {
      pattern: "/map/place/occupant-:id",
      path: `/map/place/${featureId}`,
    },
    amenity: {
      pattern: "/map/place/amenity-:id",
      path: `/map/place/${featureId}`,
    },
    promotion: {
      pattern: "/promotions/promotion-:id",
      path: `/promotions/${featureId}`,
    },
    event: {
      pattern: "/events/event-:id",
      path: `/events/${featureId}`,
    },
  }
  return _.get(routePatterns, featureType, null)
}

export const createVenueLink = (featureId) => {
  const matchPathOption = getMatchPathOptionByFeatureId(featureId)
  return matchPathOption
    ? matchPath(matchPathOption.pattern, matchPathOption.path)?.pathname
    : matchPathOption
}

export const prepareSponsoredContent = (
  entries,
  sponsoredContentConfig = {},
  featureObj = {}
) => {
  const initialData = {
    searchResult: {
      data: [],
      config: _.get(sponsoredContentConfig, "searchResult", {}),
    },
    suggestedBrand: {
      data: [],
      config: _.get(sponsoredContentConfig, "suggestedBrand", {}),
    },
    popupBanner: {
      data: [],
      config: _.get(sponsoredContentConfig, "popupBanner", {}),
    },
    screensaver: {
      data: [],
      config: _.get(sponsoredContentConfig, "screensaver", {}),
    },
    footerBanner: {
      data: [],
      config: _.get(sponsoredContentConfig, "footerBanner", {}),
    },
  }

  // Group and normalize the data
  const parsedEntries = parseEntries(_.get(entries, "data"))

  const preparedData = _(parsedEntries)
    .orderBy(["order"], ["asc"])
    .reduce((acc, entry) => {
      const camelCaseType = _.camelCase(_.get(entry, "type"))
      const limit = _.get(
        sponsoredContentConfig,
        `${camelCaseType}.limit`,
        Infinity
      )
      const isDisable = _.get(
        sponsoredContentConfig,
        `${camelCaseType}.disable`,
        false
      )

      const currentData = _.get(acc, `${camelCaseType}.data`)

      if (isDisable) return acc

      if (_.isNil(currentData)) return acc

      if (_.isFinite(currentData) && currentData && currentData.length >= limit)
        return acc

      const featureId = _.get(entry, "feature_id")
      const feature = getFeatureDetail(_.get(featureObj, featureId, null))
      const mediaSrc =
        _.get(entry, `media.formats.medium.url`) || _.get(entry, `media.url`)
      const updatedEntry = {
        ...entry,
        type: camelCaseType,
        mediaSrc,
        feature,
        link: createVenueLink(featureId),
      }

      switch (camelCaseType) {
        case "searchResult":
        case "suggestedBrand": {
          if (_.isNil(feature)) break
          acc[camelCaseType].data = [...currentData, updatedEntry]
          break
        }
        case "popupBanner":
          acc[camelCaseType].data = [...currentData, updatedEntry]
          break
        case "footerBanner":
        case "screensaver": {
          acc[camelCaseType].data = [
            ...currentData,
            {
              ...updatedEntry,
              props: createCardMediaPropsFromFileField(
                _.get(updatedEntry, "media")
              ),
            },
          ]
          break
        }
        default:
          break
      }
      return acc
    }, initialData)
  return preparedData
}
